const AgentThinkingLoader = () => (
    <div className="flex items-center justify-center gap-1">
        <div className="w-[3px] h-[3px] bg-gray-500 animate-bounce rounded-full bg-primary/20 [animation-delay:-0.2s] [animation-duration:0.70s]" />
        <div className="w-[3px] h-[3px] bg-gray-500 animate-bounce rounded-full bg-primary/20 [animation-delay:-0.10s] [animation-duration:0.70s]" />
        <div className="w-[3px] h-[3px] bg-gray-500 animate-bounce rounded-full bg-primary/20 [animation-duration:0.70s]" />
    </div>
);

export default AgentThinkingLoader;
